export default __webpack_public_path__ + "static/media/form-validation.d1b45cc6.svg";